import { render, staticRenderFns } from "./automotive.vue?vue&type=template&id=19ad8cac&"
import script from "./automotive.vue?vue&type=script&lang=js&"
export * from "./automotive.vue?vue&type=script&lang=js&"
import style0 from "./automotive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports